import PropTypes from "prop-types";
import { Dialog, DialogTitle, DialogContent, IconButton, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useICCCColors } from "../theme";

export default function DialogShell({
  open,
  onClose,
  title,
  subtitle,
  icon,
  color,
  maxWidth = "md",
  children,
}) {
  const ICCC_COLORS = useICCCColors();
  const accent = color || ICCC_COLORS.accent;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: ICCC_COLORS.cardBg,
          color: ICCC_COLORS.textPrimary,
          backgroundImage: "none",
          border: `1px solid ${ICCC_COLORS.cardBorder}`,
          borderRadius: 2,
          boxShadow: ICCC_COLORS.shadow,
          overflow: "hidden",
        },
      }}
    >
      <MDBox sx={{ height: 4, bgcolor: accent }} />

      <DialogTitle sx={{ p: 0 }}>
        <MDBox
          display="flex"
          alignItems="center"
          gap={1.5}
          sx={{
            px: 2.5,
            py: 2,
            bgcolor: ICCC_COLORS.cardBg,
            borderBottom: `1px solid ${ICCC_COLORS.divider}`,
          }}
        >
          {icon && (
            <MDBox
              sx={{
                width: 40,
                height: 40,
                borderRadius: 1.25,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                bgcolor: `${accent}1f`,
                color: accent,
                border: `1px solid ${accent}33`,
              }}
            >
              <Icon>{icon}</Icon>
            </MDBox>
          )}
          <MDBox sx={{ flex: 1, minWidth: 0 }}>
            <MDTypography
              variant="h6"
              fontWeight="bold"
              sx={{ color: ICCC_COLORS.textPrimary, lineHeight: 1.2 }}
            >
              {title}
            </MDTypography>
            {subtitle && (
              <MDTypography
                variant="caption"
                sx={{ color: ICCC_COLORS.textMuted, display: "block", mt: 0.25 }}
              >
                {subtitle}
              </MDTypography>
            )}
          </MDBox>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              color: ICCC_COLORS.textSecondary,
              "&:hover": { bgcolor: ICCC_COLORS.hoverBg, color: ICCC_COLORS.textPrimary },
            }}
            aria-label="Close dialog"
          >
            <Icon>close</Icon>
          </IconButton>
        </MDBox>
      </DialogTitle>
      <DialogContent
        sx={{
          px: 2.5,
          pt: "20px !important",
          pb: 2.5,
          bgcolor: ICCC_COLORS.cardBg,
          color: ICCC_COLORS.textPrimary,
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}

DialogShell.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  icon: PropTypes.string,
  color: PropTypes.string,
  maxWidth: PropTypes.string,
  children: PropTypes.node,
};
